/* eslint-disable react-hooks/exhaustive-deps */
import Header from "./features/header/Header";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import { useEffect } from "react";
import { getCurrentUser, passwordlessLogin } from "services/user";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { disconnect, setUser, setLoaded } from "store/app";
import { useBackendError } from "services/hooks";
import { useSnackbar } from "notistack";
import SignUp from "features/user/SignUp";
import Forgot from "features/user/Forgot";
import Login from "features/user/Login";

const Bootstrap = (props:any) => {

  const history = useHistory();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.app);
  const { handleRequestError } = useBackendError();
  const { enqueueSnackbar } = useSnackbar();

  const cleanUrl = () => {
    const { pathname, search } = location;
    const cleanUrl = search.replace(/loginToken=[^&]+&?/, '');
    history.replace(`${pathname}${cleanUrl}`);
  }
  
  const handlePasswordlessLogin = async(loginToken) => {
    try {
      console.info("---------- passwordless login")
      const response = await passwordlessLogin(loginToken);
      dispatch(setUser(response));
      cleanUrl();
      enqueueSnackbar("Welcome! You were successfully logged in.", {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    } catch(err) {
      handleRequestError(err);
      cleanUrl();
    }
  }

  const handleGetUser = async () => {
    const jwt = localStorage.getItem("jwt");
    if(!jwt) {
      dispatch(setLoaded());
      return;
    }
    try {
      console.info("---------- restoring user")
      const response = await getCurrentUser(jwt!);
      const payload = {
        jwt,
        user: response
      }
      dispatch(setUser(payload));
    } catch(err) {
      handleRequestError(err);
      dispatch(disconnect());
    }
  }

  useEffect(() => {
    const { loginToken } = queryString.parse(props.location.search);
    if(loginToken) {
      handlePasswordlessLogin(loginToken);
    } else if(!loginToken && !user) {
      handleGetUser();
    }
  },[props.location.search]);

  return (
    <>
      <Header />
      <div className="container-fluid bootstrap h-100">
        <div className="hero"/>
        {props.children}
      </div>
      <SignUp/>
      <Login/>
      <Forgot/>
    </>
  );
};

export default withRouter(Bootstrap);

